import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ARService } from '../../ar/ar.service';
import { PlanViewComponent } from '../../ar/payment-plan/plan-view/plan-view.component';
import {DataARPaymentPlanModel} from '../../../models/accountsReceivable/data-ar-payment-plan.model';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';

@Component({
  selector: 'app-patient-portal-plans',
  templateUrl: './patient-portal-plans.component.html',
  styleUrls: ['./patient-portal-plans.component.css']
})
export class PatientPortalPlansComponent implements OnInit {

  isLoading: boolean = false;
  PatientId: string;
  patientInformation: any;

  paymentPlans: DataARPaymentPlanModel[] = [];

  constructor(
    private arService: ARService,
    private dialog: MatDialog,
  ) {
    this.patientInformation = JSON.parse(localStorage.getItem('storedPatient'));
    this.PatientId = this.patientInformation.authdata.userid;
  }

  ngOnInit() {
    this.init();
  }

  async init() {

    this.isLoading = true;

    try {
      this.paymentPlans = await this.arService.getPaymentPlansForPatient(this.PatientId).toPromise();
      console.log('got plans', this.paymentPlans);

      

      this.paymentPlans.forEach(plan => {
        if (plan.enumPaymentPlanStatusID === LEDGER_ITEM_STATUS.Paid) {
          plan.DATA_IS_PAID = true;
        } else {
          plan.DATA_IS_PAID = false;
        }
      });

      console.log(this.paymentPlans);

    } catch (err) {
      console.log('err', err);
    }

    this.isLoading = false;

  }

  openReportForSelectedOption(paymentPlan: DataARPaymentPlanModel) {

    const dialogRef = this.dialog.open(PlanViewComponent, {
      width: '90%',
      height: '90%',
      disableClose: true,
      data: {
        paymentPlan,
        PatientId: this.PatientId,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.init();
      }
    }, err => {
    });

  }

}
